import React, { ReactElement, useMemo } from 'react'

import { Icon, IconName, IconSize } from '../../Icon'
import { Size as ButtonSize, Size } from '../types'
import * as Styled from './styles'
import { Position } from './types'

export interface ButtonIconProps {
  icon?: IconName
  isVisible: boolean
  loading?: boolean
  position: Position
  size: ButtonSize
  withIconMargin?: boolean
}

const iconSize: Record<Size, IconSize> = {
  sm: 'sm',
  md: 'sm',
  lg: 'md',
}

export const ButtonIcon = ({
  icon,
  isVisible,
  loading,
  position,
  size,
  withIconMargin,
}: ButtonIconProps): ReactElement | null => {
  const iconWrapperProps = useMemo(
    () => ({
      visible: isVisible,
      loading,
      position,
      size,
      withIconMargin,
    }),
    [loading, position, size, withIconMargin, isVisible],
  )

  return (
    // It has to be always wrapped in element due to the chromium bug:
    // https://github.com/facebook/react/issues/11538
    <Styled.IconWrapper {...iconWrapperProps}>
      {useMemo(() => {
        if (loading) {
          return <Icon color="currentColor" icon="circleDashed" size={iconSize[size]} />
        }

        if (!icon) {
          return null
        }

        return typeof icon === 'string' ? <Icon color="currentColor" icon={icon} size={iconSize[size]} /> : icon
      }, [icon, loading, size])}
    </Styled.IconWrapper>
  )
}
